/** @format */
import {
  POST_ACTIVITY_REQUEST,
  POST_ACTIVITY_SUCCESS,
  POST_ACTIVITY_FAILURE,
} from "./PostActivityTypes";

const initialState = {
  loading: false,
  response: {},
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_ACTIVITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case POST_ACTIVITY_SUCCESS:
      return {
        loading: false,
        response: action.payload,
        error: "",
      };
    case POST_ACTIVITY_FAILURE:
      return {
        loading: false,
        response: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
